import {
  DatagridConfigurable,
  TextField,
  DateField,
  FunctionField,
  useListContext
} from 'react-admin';
import { useRowStyle } from '../../../../hooks/useRowStyle';
import { TotalRows } from '../../../helperComponents/TotalRows';
import { StatusChip } from './components/StatusChip';
import { truncate } from '../../../../helpers/adsActionsHelpers';

export const AdsActionsDataGrid = () => {
  const rowClassName = useRowStyle();
  const { total } = useListContext();

  return (
    <>
      <TotalRows total={total} />
      <DatagridConfigurable
        rowClick="show"
        className={`${rowClassName} datagrid-content`}
        bulkActionButtons={false}
      >
        <TextField source="id" label="ID" />
        <TextField source="account_name" label="Account Name" />
        <TextField source="entity_type" label="Entity Type" />
        <TextField source="entity_id" label="Entity ID" />
        <TextField source="action" label="Action" />
        <FunctionField
          source="params"
          label="Params"
          sortable={false}
          render={(record) => truncate(JSON.stringify(record.params || {}), 60)}
        />
        <FunctionField
          source="reason"
          label="Reason"
          render={(record) => (
            <span title={record.reason}>{truncate(record.reason || '', 80)}</span>
          )}
        />
        <TextField source="proposed_by" label="Proposed By" />
        <DateField source="proposed_at" label="Proposed At" showTime />
        <FunctionField
          source="status"
          label="Status"
          render={(record) => <StatusChip status={record.status} />}
        />
        <TextField source="approved_by" label="Approved By" />
        <DateField source="executed_at" label="Executed At" showTime />
      </DatagridConfigurable>
    </>
  );
};
